<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        Developer Logs
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            Other
        </li>
        <li class="breadcrumb-item position-relative">
            Developer Logs
        </li>
    </ol>
</div>

<mat-card class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            <h5 class="mb-0">
                Developer Logs
            </h5>
        </mat-card-title>
        <mat-card-subtitle>
            <!-- filters -->
            <button mat-raised-button class="daxa" (click)="openFiltersDialog()">
                Filters
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource">
                <!-- ID Column -->
                <ng-container matColumnDef="ID">
                    <th mat-header-cell *matHeaderCellDef>
                        ID
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.id }}
                    </td>
                </ng-container>

                <!-- Severity Column -->
                <ng-container matColumnDef="severity">
                    <th mat-header-cell *matHeaderCellDef>
                        Severity
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.severity }}
                    </td>
                </ng-container>

                <!--Method Column -->
                <ng-container matColumnDef="method">
                    <th mat-header-cell *matHeaderCellDef>
                        Method
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.method }}
                    </td>
                </ng-container>

                <!-- Message Column -->
                <ng-container matColumnDef="message">
                    <th mat-header-cell *matHeaderCellDef>
                        Message
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ truncateString(element.msg) }}
                    </td>
                </ng-container>

                <!-- Request path Column -->
                <ng-container matColumnDef="requestPath">
                    <th mat-header-cell *matHeaderCellDef>
                        Request Path
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ truncateString(element.requestPath) }}
                    </td>
                </ng-container>

                <!-- Time Column -->
                <ng-container matColumnDef="time">
                    <th mat-header-cell *matHeaderCellDef>
                        Time
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{ element.timestampStr }}
                    </td>
                </ng-container>
                <!-- Action Column -->
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>
                        Action
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="action-info">
                            <button mat-button class="daxa" (click)="openLogDetails(element)">
                                <i class="material-symbols-outlined">
                                    visibility
                                </i>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <!-- second-header -->
                <ng-container matColumnDef="header-row-group" *ngIf="isLoading" colspan="7">
                    <th mat-header-cell *matHeaderCellDef [attr.colspan]="7" class="second-header-row">

                        <app-buffer-progress-bar mode="indeterminate"></app-buffer-progress-bar>
                    </th>
                </ng-container>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                <tr mat-header-row *matHeaderRowDef="isLoading ? ['header-row-group'] : []"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="7" *ngIf="!isLoading">
                        No data matching the filter
                    </td>
                </tr>
            </table>
        </div>
        <mat-paginator [length]="totalLogs" [pageSize]="pageSize"   [pageSizeOptions]="[8, 20, 30]" 
        [pageIndex]="currentPage - 1" (page)="onPageChange($event)">
        </mat-paginator>    
    </mat-card-content>
</mat-card>